const team = {
  'team-management.invite.error':
    'An error occured while attempting to delete the invite. Please try again or contact support.',
  'team-management.players.list.header': 'Players ({{ players }})',
  'team-management.amount.players': '{{ players }} Players',
  'team-management.players.list.item.header.you': '{{ name }} (you)',
  'team-management.players.list.item.subheader': 'Trained {{ timeAgo }}',
  'team-management.players.list.item.subheader.alt': 'No activity yet',
  'team-management.invites.list.header': 'Invites',
  'team-management.invites.list.item.sent': 'Sent {{ timeAgo }}',
  'team-management.invites.list.item.declined': 'Declined',
  'team-management.invite-button': 'Invite Players ({{ invitesLeft }} left)',
  'team-management.no-team': 'You do not have a Team to manage.',
  'team-management.no-team.action': 'Set up Team',
  'team-management.no-permission': 'A Team is granting you access, so you cannot create and manage your own.',
  'team-management.invite.drawer.title': 'Invite Team Members',
  'team-management.invite.drawer.submit': 'Invite',
};

const player = {
  "team-management.player.info.league": "{{ league }} League, Division {{ division }}",
  "team-management.player.info.age": "{{ age }} years old",
  "team-management.player.remove": "Remove",
  "team-management.player.remove.confirm.title": "Remove Player?",
  "team-management.player.remove.confirm.body": "Are you sure you want to remove this Player from you Team",
  "team-management.player.view-progress": "View Progress",
  "team-management.player.skill-radar.title": "Skill Radar",
  "team-management.player.stats.title": "Stats ({{ dateRange }})",
  "team-management.player.stats.filter": "Change Date Range",
  "team-management.player.progress-chart.placeholder": "No training data for the selected period",
  "team-management.player.metric-results.placeholder": "No training data for the selected period",
  "team-management.player.metric-results.title": "Metric Results",
  "team-management.player.activity-card.title": "Activity",
  "team-management.player.training-card.title": "Training",
  "team-management.player.training-card.label": "Sessions",
};

export const teamManagement = { ...player, ...team };
